import Config from "../config";
import { Child } from "../models";

/**
 * Generate a child profile image URL with cache-busting parameter
 * Uses modifiedCentralDateTime to ensure fresh images are fetched after profile updates
 */
export function getChildImageUrl(childId: number, modifiedCentralDateTime?: string): string {
  const baseUrl = `${Config.api.uri}/children/${childId}.jpg`;

  if (!modifiedCentralDateTime) {
    return baseUrl;
  }

  // Use timestamp from modifiedCentralDateTime as cache buster
  // This ensures the browser fetches a new image when the child record is updated
  const timestamp = new Date(modifiedCentralDateTime).getTime();
  return `${baseUrl}?t=${timestamp}`;
}

/**
 * Generate a child profile image URL from a Child object
 */
export function getChildImageUrlFromChild(child?: Child): string {
  if (!child) {
    return `${Config.api.uri}/children/0.jpg`;
  }
  return getChildImageUrl(child.id, child.modifiedCentralDateTime);
}
